export default __webpack_public_path__ + "static/media/up-arrow.72b6228a.png";